export const RAILWAY_CLI_VERSION = '5.26.4'
/**
 * Unpinned because `vercel@48` mishandles `integration add neon` on accounts that already have
 * the Neon integration installed — it retries the install and fails with "Cannot install more
 * than one integration at a time" instead of provisioning a resource. v54+ handles it correctly.
 */
export const VERCEL_CLI_VERSION = 'latest'
export const PINNED_PNPM_PACKAGE_MANAGER = 'pnpm@11.9.0'
export const MIN_SUPPORTED_PNPM_MAJOR = 9
